import { useEffect, useRef } from "react";
import TagManager from "react-gtm-module";

const scrollDepthsList = {
	expert: ["", "WHITC3YK", "TJVD56IW", "JKZGJLVC", "FO9VNNMT"],
	client: ["", "25%", "50%", "75%", "90%"],
};

const scrollDepths = [0, 25, 50, 75, 90];

export const usePageScrollHook = (eventType: "client" | "expert") => {
	const scrollTriggered = useRef<any>({});

	const handleScroll = () => {
		const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
		const scrollPosition = window.scrollY;
		const currentScrollPercent = (scrollPosition / scrollHeight) * 100;

		scrollDepths.forEach((depth, index) => {
			const eventId = scrollDepthsList[eventType][index];
			if (currentScrollPercent >= depth && !scrollTriggered?.current?.[depth] && eventId) {
				scrollTriggered.current[depth] = true;
				const tagManagerArgs = {
					dataLayer: {
						event: `client-scroll`,
						depth: eventId,
					},
				};
				TagManager.dataLayer(tagManagerArgs);
			}
		});
	};
	//

	useEffect(() => {
		const eventId = scrollDepthsList[eventType][0];
		if (eventId) {
			scrollTriggered.current[0] = true;
			const tagManagerArgs = {
				dataLayer: {
					event: `client-scroll`,
					depth: eventId,
				},
			};
			TagManager.dataLayer(tagManagerArgs);
		}
	}, [eventType]);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);
};
